<template>
  <div
    class="w-full h-screen flex flex-col justify-center items-center gap-6 p-4 bg-gradient-to-br from-eyecare-blue-50 to-eyecare-blue-100"
  >
    <div class="text-center max-w-md">
      <!-- Logo da EyecareHealth -->
      <div class="mb-8">
        <img
          src="@/assets/images/eyecare-logo-colored.png"
          alt="EyecareHealth"
          class="mx-auto"
          style="max-width: 230px; height: auto;"
        />
      </div>

      <!-- Ícone de manutenção -->
      <div class="mb-6">
        <svg
          class="w-12 h-12 mx-auto"
          fill="none"
          stroke="#0c1d59"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      </div>

      <h1 class="text-4xl font-bold text-dark-blue mb-4">
        Sistema em Manutenção
      </h1>
      <p class="text-lg text-neutral-600 mb-2">
        Estamos realizando melhorias no sistema para oferecer uma experiência
        ainda melhor.
      </p>
      <p class="text-sm text-neutral-500">
        Por favor, tente novamente em alguns instantes.
      </p>
    </div>
    <div class="mt-4">
      <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-eyecare-blue-500 mx-auto"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Maintenance',
  mounted() {
    // Previne qualquer tentativa de navegação via botões do navegador
    window.history.pushState(null, null, '/manutencao')
    window.addEventListener('popstate', this.preventNavigation)
  },
  beforeDestroy() {
    window.removeEventListener('popstate', this.preventNavigation)
  },
  methods: {
    preventNavigation() {
      // Impede navegação via botões do navegador (voltar/avançar)
      window.history.pushState(null, null, '/manutencao')
    }
  }
}
</script>

<style scoped>
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
